import axios from "axios"
import { env } from '../constants'

/* CREATE ROUTE */
export const create = data => {
    const uri = `${env.startpoint}user/create`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* REMOVE ROUTE */
export const remove = data => {
    const uri = `${env.startpoint}user/remove`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}